<template>
  <div>
    <section class="content">
      <div
        class="pull-right btn-information col-xs-2"
        v-show="isSuperAdmin"
      >
        <button
          class="btn btn-info btn-information-save"
          v-on:click="handleSave"
        >Save</button>
        <button
          class="btn btn-default btn-information-cancel"
          v-on:click="goBack"
        >Cancel</button>
      </div>

      <device-addon-form ref="form" withInitialData/>
    </section>
  </div>
</template>
<script>
import DeviceAddonForm from "../modules/DeviceAddonForm";
import utils from "../../utils";

export default {
  name: "DeviceAddon",
  components: {
    DeviceAddonForm
  },
  data() {
    return {
      isSuperAdmin: utils.checkIsSuperAdmin()
    };
  },
  methods: {
    async handleSave() {
      await this.$refs.form.update();
    },
    goBack() {
      this.$router.push("/");
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// DeviceAddon.vue?d0bef322